module.exports = __webpack_public_path__ + "img/paymera.ba434ddc.jpg";